import {ParamsModel} from 'src/app/modules/common/Model'
import {NabilAuctionModel, SortNabilAuctionModel} from '../Model/Model'
import {actionTypes} from './constants'

export const actions = {
  // get all NabilAuction
  getAllNabilAuction: () => ({
    type: actionTypes.GET_ALL_NABIL_AUCTION_START,
  }),
  getAllNabilAuctionSuccess: (data: NabilAuctionModel | any) => ({
    type: actionTypes.GET_ALL_NABIL_AUCTION_SUCCESS,
    payload: data,
  }),
  getAllNabilAuctionFinish: () => ({
    type: actionTypes.GET_ALL_NABIL_AUCTION_FINISH,
  }),

  // get NabilAuction DATA
  getNabilAuction: (params: ParamsModel = {page: 1, limit: 10}) => ({
    type: actionTypes.GET_NABIL_AUCTION_START,
    payload: params,
  }),
  getNabilAuctionSuccess: (data: NabilAuctionModel | any) => ({
    type: actionTypes.GET_NABIL_AUCTION_SUCCESS,
    payload: data,
  }),
  getNabilAuctionFinish: () => ({
    type: actionTypes.GET_NABIL_AUCTION_FINISH,
  }),

  // create
  addNabilAuction: (data: NabilAuctionModel | any) => ({
    type: actionTypes.ADD_NABIL_AUCTION_START,
    payload: data,
  }),
  addNabilAuctionSuccess: (task: any) => ({
    type: actionTypes.ADD_NABIL_AUCTION_SUCCESS,
    payload: task,
  }),
  addNabilAuctionFinish: () => ({
    type: actionTypes.ADD_NABIL_AUCTION_FINISH,
  }),
  resetNabilAuction: () => ({
    type: actionTypes.RESET_NABIL_AUCTION,
  }),

  // Update NabilAuction
  updateNabilAuction: (data: NabilAuctionModel | any, id: string) => ({
    type: actionTypes.UPDATE_NABIL_AUCTION_START,
    payload: data,
    id,
  }),
  updateNabilAuctionSuccess: (data: NabilAuctionModel | any) => ({
    type: actionTypes.UPDATE_NABIL_AUCTION_SUCCESS,
    payload: data,
  }),
  updateNabilAuctionFinish: () => ({
    type: actionTypes.UPDATE_NABIL_AUCTION_FINISH,
  }),

  // delete
  deleteNabilAuction: (data: string[]) => ({
    type: actionTypes.DELETE_NABIL_AUCTION_START,
    payload: {ids: data},
  }),
  deleteNabilAuctionSuccess: (data: any) => ({
    type: actionTypes.DELETE_NABIL_AUCTION_SUCCESS,
    payload: data,
  }),
  deleteNabilAuctionFinish: () => ({
    type: actionTypes.DELETE_NABIL_AUCTION_FINISH,
  }),

  // Enable NabilAuction
  enableNabilAuction: (data: any) => ({
    type: actionTypes.ENABLE_NABIL_AUCTION_REQUEST,
    payload: {data},
  }),
  enableNabilAuctionSuccess: (task: any) => ({
    type: actionTypes.ENABLE_NABIL_AUCTION_SUCCESS,
    payload: task,
  }),
  enableNabilAuctionFinish: () => ({
    type: actionTypes.ENABLE_NABIL_AUCTION_FINISH,
  }),

  // Disable NabilAuction
  disableNabilAuction: (data: any) => ({
    type: actionTypes.DISABLE_NABIL_AUCTION_REQUEST,
    payload: {data},
  }),
  disableNabilAuctionSuccess: (task: any) => ({
    type: actionTypes.DISABLE_NABIL_AUCTION_SUCCESS,
    payload: task,
  }),
  disableNabilAuctionFinish: () => ({
    type: actionTypes.DISABLE_NABIL_AUCTION_FINISH,
  }),

  // Single Enable NabilAuction
  singleEnableNabilAuction: (data: any) => ({
    type: actionTypes.SINGLE_ENABLE_NABIL_AUCTION_REQUEST,
    payload: {data},
  }),
  singleEnableNabilAuctionSuccess: (task: any) => ({
    type: actionTypes.SINGLE_ENABLE_NABIL_AUCTION_SUCCESS,
    payload: task,
  }),
  singleEnableNabilAuctionFinish: () => ({
    type: actionTypes.SINGLE_ENABLE_NABIL_AUCTION_FINISH,
  }),

  // Single Disable NabilAuction
  singleDisableNabilAuction: (data: any) => ({
    type: actionTypes.SINGLE_DISABLE_NABIL_AUCTION_REQUEST,
    payload: {data},
  }),
  singleDisableNabilAuctionSuccess: (task: any) => ({
    type: actionTypes.SINGLE_DISABLE_NABIL_AUCTION_SUCCESS,
    payload: task,
  }),
  singleDisableNabilAuctionFinish: () => ({
    type: actionTypes.SINGLE_DISABLE_NABIL_AUCTION_FINISH,
  }),

  // sort
  sortNabilAuction: (data: SortNabilAuctionModel) => ({
    type: actionTypes.SORT_NABIL_AUCTION_START,
    payload: data,
  }),
  sortNabilAuctionSuccess: (data: Array<NabilAuctionModel>) => ({
    type: actionTypes.SORT_NABIL_AUCTION_SUCCESS,
    payload: data,
  }),
  sortNabilAuctionFinish: () => ({
    type: actionTypes.SORT_NABIL_AUCTION_FINISH,
  }),
  sortNabilAuctionReset: () => ({
    type: actionTypes.SORT_NABIL_AUCTION_RESET,
  }),

  // category list for dropdown
  getNabilAuctionCategoryList: () => ({
    type: actionTypes.GET_NABIL_AUCTION_CATEGORY_LIST_START,
  }),
  getNabilAuctionCategoryListSuccess: (data: any) => ({
    type: actionTypes.GET_NABIL_AUCTION_CATEGORY_LIST_SUCCESS,
    payload: data,
  }),
  getNabilAuctionCategoryListFinish: () => ({
    type: actionTypes.GET_NABIL_AUCTION_CATEGORY_LIST_FINISH,
  }),
}
